import React from 'react';
import { FONT } from '../../../shared';

// Google_Search_Ad — Google search ad result card
// Reference: Vella_Preview_Mockup_Spec.md (Google Ads)
// Standard SERP result · "Ad" badge green · headline blue · display URL green
export default function GoogleSearchAdChrome({
  headline = "Your Brand — Best Pricing in 2026",
  headline2,
  headline3,
  displayUrl = "yourbrand.com/offer",
  description = "Limited-time offer on our top products. Free shipping on orders over $50. Shop the new collection today.",
  description2,
  sitelinks = [],
  brandName = "Your Brand",
}) {
  const headlineParts = [headline, headline2, headline3].filter(Boolean);

  return (
    <div style={{ fontFamily: FONT, background: "#F1F3F4", color: "#202124", width: "100%", maxWidth: 390, borderRadius: 12, overflow: "hidden", border: "1px solid #DADCE0" }}>
      {/* Status bar */}
      <div style={{ height: 20, background: "#FFFFFF", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 14px", fontSize: 11, fontWeight: 600 }}>
        <span>{new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</span>
        <span style={{ letterSpacing: 1, fontSize: 10 }}>••• 5G 100</span>
      </div>

      {/* Google search header */}
      <div style={{ height: 56, background: "#FFFFFF", display: "flex", alignItems: "center", padding: "0 14px", gap: 10, borderBottom: "1px solid #EBEBEB" }}>
        <span style={{ fontSize: 18, fontWeight: 500, letterSpacing: -0.5 }}>
          <span style={{ color: "#4285F4" }}>G</span>
          <span style={{ color: "#EA4335" }}>o</span>
          <span style={{ color: "#FBBC04" }}>o</span>
          <span style={{ color: "#4285F4" }}>g</span>
          <span style={{ color: "#34A853" }}>l</span>
          <span style={{ color: "#EA4335" }}>e</span>
        </span>
        <div style={{ flex: 1, height: 36, borderRadius: 999, border: "1px solid #DFE1E5", background: "#FFFFFF", padding: "0 14px", display: "flex", alignItems: "center", fontSize: 13, color: "#202124" }}>
          {brandName.toLowerCase()}
        </div>
      </div>

      {/* Search filter chips */}
      <div style={{ height: 36, background: "#FFFFFF", display: "flex", alignItems: "center", gap: 14, padding: "0 14px", fontSize: 12, color: "#5F6368", borderBottom: "1px solid #EBEBEB", overflow: "hidden" }}>
        <span style={{ color: "#1A0DAB", borderBottom: "2px solid #1A73E8", paddingBottom: 9, fontWeight: 500 }}>All</span>
        <span>Images</span>
        <span>Shopping</span>
        <span>News</span>
        <span>Maps</span>
      </div>

      {/* Ad result */}
      <div style={{ background: "#FFFFFF", padding: "14px 16px 16px" }}>
        {/* Ad badge + advertiser */}
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: "#0F9D58", border: "1px solid #0F9D58", borderRadius: 3, padding: "0 4px", lineHeight: "16px" }}>Ad</span>
          <span style={{ fontSize: 12, color: "#202124" }}>·</span>
          <span style={{ fontSize: 12, color: "#202124", fontWeight: 500 }}>{displayUrl.split("/")[0]}</span>
        </div>

        {/* Display URL */}
        <div style={{ fontSize: 12, color: "#202124", marginBottom: 4 }}>
          <span style={{ color: "#5F6368" }}>https://</span>
          <span>{displayUrl}</span>
        </div>

        {/* Headline */}
        <div style={{ fontSize: 18, lineHeight: 1.3, color: "#1A0DAB", fontWeight: 400, marginBottom: 4, cursor: "pointer" }}>
          {headlineParts.join(" | ")}
        </div>

        {/* Description */}
        <div style={{ fontSize: 13, lineHeight: 1.45, color: "#4D5156" }}>
          {description}{description2 ? ` ${description2}` : ""}
        </div>

        {/* Sitelinks */}
        {sitelinks.length > 0 && (
          <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 18px" }}>
            {sitelinks.slice(0, 4).map((sl, i) => (
              <div key={i}>
                <div style={{ fontSize: 14, color: "#1A0DAB", lineHeight: 1.3, marginBottom: 2 }}>
                  {typeof sl === "string" ? sl : sl.title}
                </div>
                {typeof sl === "object" && sl.description && (
                  <div style={{ fontSize: 11, color: "#4D5156", lineHeight: 1.4 }}>{sl.description}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Organic result placeholder for context */}
      <div style={{ background: "#FFFFFF", padding: "12px 16px 16px", borderTop: "1px solid #EBEBEB" }}>
        <div style={{ fontSize: 12, color: "#202124", marginBottom: 2 }}>{brandName.toLowerCase().replace(/\s+/g, "")}.com</div>
        <div style={{ fontSize: 16, color: "#1A0DAB", lineHeight: 1.3, marginBottom: 2 }}>
          {brandName} — Official Site
        </div>
        <div style={{ fontSize: 12, color: "#4D5156", lineHeight: 1.4, opacity: 0.55 }}>
          Discover everything {brandName} has to offer. Shop new arrivals, explore collections...
        </div>
      </div>
    </div>
  );
}
